<template>
	<div class="curve" ref="echarts"></div>
</template>

<script>
	import {downloadFile} from "../util/fileUtil"
	const echarts = require("echarts");
	export default {
		name: "Curve",
		props: ["chartsData"],
		data(){
			return {
				myChart: null,
			}
		},
		computed:{
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
			routeName() {
				return this.$route.params.name
			},
			tag() {
				return this.$route.params.tag
			},
		},
		watch: {
			diagramStatus(n){
				if(n.type === 'echarts'){
					let data = this.myChart.getDataURL({
						type: "jpeg",
						backgroundColor: "#fff",
						pixelRatio: 2,
					})

					let name = ''
					if (this.routeName === 'PowerData' && this.tag === 'none') {
						name = '回路监测'
					} else if (this.routeName === 'Transformer' && this.tag === 'none') {
						name = '变压器监测'
					} else if (this.routeName === 'Breaker' && this.tag === 'none') {
						name = '断路器监测'
					} else if (this.routeName === 'PowerQuality' && this.tag === 'none') {
						name = '谐波分析'
					}

					downloadFile(name + new Date().toLocaleString(), data)
				}
			},
			chartsData(n, o) {
				this.myChart.clear()
				this.myChart.setOption(n);
			},
		},
		mounted() {
			let myChart = echarts.init(this.$refs.echarts);
			this.myChart = myChart

			this.myChart.setOption(this.chartsData);

			window.addEventListener("resize", () => {
				this.myChart.resize();
			});
		},
		methods:{
			merge(o1, o2){
				for (const key in o2) {
					if (Object.hasOwnProperty.call(o2, key) && o1[key]) {
						if(typeof o2[key]  === 'object' && typeof o1[key] === 'object'){
							this.merge(o1[key], o2[key])
						}else {
							o1[key] = o2[key]
						}

					}else {
						o1[key] = o2[key]
					}
				}
			}
		}
	}
</script>

<style scoped lang="less">
.curve {
	width: 100%;
	height: 100%;
}
</style>